module.exports = __webpack_public_path__ + "static/media/BUBS.82516ed9.png";